import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import moment from 'moment';

function FundingNextRepaymentDate({ fundingRepaymentMode, fundingNextRepaymentDate }) {
  const disabled = fundingRepaymentMode === 'FORCE' || fundingRepaymentMode === 'CUSTOM';

  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label className={disabled ? 'bo-text-light-gray' : ''}>
          Next Repayment Date:
        </Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className={`bo-input ${disabled ? 'bg-light' : ''}`}
          type="text"
          name="nextDate"
          id="nextDate"
          value={
            fundingNextRepaymentDate
              ? moment.utc(fundingNextRepaymentDate).format('MMM DD, YYYY')
              : ''
          }
          readOnly
          disabled={disabled}
        />
      </Col>
    </>
  );
}

export default memo(FundingNextRepaymentDate);
